import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { ParameterDDL } from '../../../../../../Components/CommonDDL/ParameterDDL';
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { TimeDDL } from '../../../../../../Components/CommonDDL/TimeDDL';
import { WTPWaterQtyDataAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/DataUploadSlice/DataUploadSlice';
import { useSearchParams } from 'react-router-dom';


export default function WTPWaterQualityDataUploadPagePopupFirst(props) {

    const { handleOnCloseClick, open, Flag, IsPost, setIsPost } = props

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    // let HWard = searchParams.get("WardName")
    // let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    // const [ReadingData, setReadingData] = useState(moment().format('YYYY-MM-DD'))
    const [ReadingData, setReadingData] = useState()
    const [RawWater, setRawWater] = useState('')
    const [SettledWater, setSettledWater] = useState('')
    const [PureWater, setPureWater] = useState('')
    const [FilterWater, setFilterWater] = useState('')
    const [LiterHours, setLiterHours] = useState('')
    const [KGHours, setKGHours] = useState('')
    const [PPM, setPPM] = useState('')
    const [loading, setloading] = useState(false)

    const [ParameterID, setParameterID] = useState({
        DDL: [],
        ID: localStorage.getItem('ParameterID') ? localStorage.getItem('ParameterID') : 0,
        Label: localStorage.getItem('FinancialIDLabel') ? localStorage.getItem('FinancialIDLabel') : 'Select...',
    })

    const [TimeID, setTimeID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const monthId = moment(ReadingData).month() + 1;
    console.log(monthId); // 2


    const handleSubmit = () => {
        const data = {
            M_FinancialYearID: year.ID,
            M_MonthID: monthId,
            WaterQtyM_IndicatorID: ParameterID.ID ? ParameterID.ID : 0,
            M_WTP_TimeID: TimeID.ID ? TimeID.ID : 0,
            ReadingDate: ReadingData,
            RawWater: RawWater ? RawWater : 0,
            SettledWater: SettledWater ? SettledWater : 0,
            FilteredWater: FilterWater ? FilterWater : 0,
            PureWater: PureWater ? PureWater : 0,
            LiterHours: LiterHours ? LiterHours : 0,
            PPM: PPM ? PPM : 0,
            KGHours: KGHours ? KGHours : 0,
            // Lit: '',
            M_UserID: UserID,
            token: token,
            setloading: setloading,
            handleIsPost: handleIsPost,
            // handleFieldClear: handleFieldClear
            handleFieldClear: ''

            // handleOnCloseClick: handleOnCloseClick
        }
        // console.log('data',data)
        dispatch(WTPWaterQtyDataAPI({ data }))
    }

    const handleFieldClear = () => {
        setTimeID({
            ...TimeID,
            ID: 0,
            Label: 'Select...',
        })
        setRawWater('')
        setSettledWater('')
        setFilterWater('')
        setPureWater('')
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const [Validate, setValidate] = useState(false)


    useEffect(() => {
        handleDDLValidation()
    }, [ParameterID.ID, RawWater, SettledWater, FilterWater, PureWater, LiterHours, PPM, KGHours, TimeID.ID])

    const handleDDLValidation = () => {
        if (ParameterID.ID == 28 || ParameterID.ID == 29 || ParameterID.ID == 30 || ParameterID.ID == 31) {
            if (RawWater == '' || SettledWater == '' || FilterWater == '' || PureWater == '' || TimeID.ID == 0) {
                setValidate(false)
            } else {
                setValidate(true)
            }
        }
        if (ParameterID.ID == 32) {
            if (LiterHours == '' || TimeID.ID == 0) {
                setValidate(false)
            } else {
                setValidate(true)
            }
        }
        if (ParameterID.ID == 33) {
            if (LiterHours == '' || PPM == '' || TimeID.ID == 0) {
                setValidate(false)
            } else {
                setValidate(true)
            }
        }
        if (ParameterID.ID == 34 || ParameterID.ID == 35) {
            if (KGHours == '' || PPM == '' || TimeID.ID == 0) {
                setValidate(false)
            } else {
                setValidate(true)
            }
        }
        // if (TimeID.ID == 0) {
        //     setValidate(false)
        // } else {
        //     setValidate(true)
        // }
    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Quality</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">

                                <div className="col-12 col-lg-6">
                                    <label for=""><b>Parameter </b></label>
                                    <ParameterDDL
                                        ParameterID={ParameterID}
                                        setParameterID={setParameterID}
                                        Flag="Master"
                                    />

                                </div>

                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"> <b>Date </b></label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="FromDate"
                                            value={ReadingData}
                                            max={moment().format('YYYY-MM-DD')}
                                            onChange={(e) => (setReadingData(e.target.value))}
                                        />

                                    </div>
                                </div>

                                <div className="col-12 col-lg-6">
                                    <label for=""><b>Time </b></label>
                                    <TimeDDL
                                        TimeID={TimeID}
                                        setTimeID={setTimeID}
                                    />

                                </div>

                                {
                                    (ParameterID.ID == 28 || ParameterID.ID == 29 || ParameterID.ID == 30 || ParameterID.ID == 31) &&
                                    <>
                                        <div className="col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Raw Water </b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="workName"
                                                    aria-describedby="emailHelp"
                                                    name='workName'
                                                    value={RawWater}
                                                    onChange={(e) => (setRawWater(e.target.value))}
                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Settled Water </b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="workName"
                                                    aria-describedby="emailHelp"
                                                    name='workName'
                                                    value={SettledWater}
                                                    onChange={(e) => (setSettledWater(e.target.value))}
                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Filtered Water </b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="workName"
                                                    aria-describedby="emailHelp"
                                                    name='workName'
                                                    value={FilterWater}
                                                    onChange={(e) => (setFilterWater(e.target.value))}
                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Pure Water </b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="workName"
                                                    aria-describedby="emailHelp"
                                                    name='workName'
                                                    value={PureWater}
                                                    onChange={(e) => (setPureWater(e.target.value))}
                                                />

                                            </div>
                                        </div>
                                    </>
                                }

                                {
                                    ParameterID.ID == 32 &&
                                    <div className="col-md-6 col-lg-6">
                                        <div className="form-group">
                                            <label className="d-block" htmlFor="NameofDepartment"><b>Lit/Hrs </b></label>
                                            <input type="text"
                                                className="form-control"
                                                id="workName"
                                                aria-describedby="emailHelp"
                                                name='workName'
                                                value={LiterHours}
                                                onChange={(e) => (setLiterHours(e.target.value))}
                                            />

                                        </div>
                                    </div>
                                }

                                {
                                    ParameterID.ID == 33 &&
                                    <>
                                        <div className="col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Lit/Hrs </b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="workName"
                                                    aria-describedby="emailHelp"
                                                    name='workName'
                                                    value={LiterHours}
                                                    onChange={(e) => (setLiterHours(e.target.value))}
                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>PPM </b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="workName"
                                                    aria-describedby="emailHelp"
                                                    name='workName'
                                                    value={PPM}
                                                    onChange={(e) => (setPPM(e.target.value))}
                                                />

                                            </div>
                                        </div>
                                    </>
                                }


                                {
                                    (ParameterID.ID == 34 || ParameterID.ID == 35) &&
                                    <>
                                        <div className="col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Kg/Hrs </b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="workName"
                                                    aria-describedby="emailHelp"
                                                    name='workName'
                                                    value={KGHours}
                                                    onChange={(e) => (setKGHours(e.target.value))}
                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>PPM </b></label>
                                                <input type="text"
                                                    className="form-control"
                                                    id="workName"
                                                    aria-describedby="emailHelp"
                                                    name='workName'
                                                    value={PPM}
                                                    onChange={(e) => (setPPM(e.target.value))}
                                                />

                                            </div>
                                        </div>
                                    </>
                                }

                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        // disabled={RawWater == '' || SettledWater == '' || FilterWater == '' || PureWater == '' || TimeID.ID == 0}
                                        disabled={!Validate}
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handleSubmit()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}





// API Response (04-02-2025) LIVE http://newapi.nmmcsmartservices.com
// {
//     "code": 200,
//     "message": "Successful",
//     "url": null,
//     "status": true,
//     "data": {
//       "table": [
//         {
//           "m_IndicatorID": 28,
//           "indicatorName": "Temperature (°C)"
//         },
//         {
//           "m_IndicatorID": 29,
//           "indicatorName": "Turbidity (N.T.U.)"
//         },
//         {
//           "m_IndicatorID": 30,
//           "indicatorName": "P.H. Value"
//         },
//         {
//           "m_IndicatorID": 31,
//           "indicatorName": "Residual Chlorine ( PPM)"
//         },
//         {
//           "m_IndicatorID": 32,
//           "indicatorName": "Rate Of Raw Water"
//         },
//         {
//           "m_IndicatorID": 33,
//           "indicatorName": "Coagulant Aid"
//         },
//         {
//           "m_IndicatorID": 34,
//           "indicatorName": "Pre Chlorination"
//         },
//         {
//           "m_IndicatorID": 35,
//           "indicatorName": "Post Chlorination"
//         }
//       ]
//     }
//   }